module.exports = __webpack_public_path__ + "img/ruan3.4face86f.jpg";